import { render, staticRenderFns } from "./addClass.vue?vue&type=template&id=ff075f34&scoped=true&"
import script from "./addClass.vue?vue&type=script&lang=js&"
export * from "./addClass.vue?vue&type=script&lang=js&"
import style0 from "./addClass.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addClass.vue?vue&type=style&index=1&id=ff075f34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff075f34",
  null
  
)

component.options.__file = "addClass.vue"
export default component.exports